// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {TrainingRoomGroup} from "@models";
import {SimTrainingRoomService} from "@services";
import {Translations} from "@translations";
import {VMAutoCompleteNormal} from "../../../../../shared/shared-components/sim-advanced-inputs/sim-base-chip-input/sim-base-chip-input.component";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_CreateNonSimstationRoomInput extends MatDialogDataBaseInput {}

export interface DialogData_CreateNonSimstationRoomOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-create-non-simstation-room-dialog",
	templateUrl: "./create-non-simstation-room-dialog.component.html",
	styleUrls: ["./create-non-simstation-room-dialog.component.scss"],
	standalone: false,
})
export class CreateNonSimstationRoomDialogComponent extends BasicMaterialDialog<
	CreateNonSimstationRoomDialogComponent,
	DialogData_CreateNonSimstationRoomInput,
	DialogData_CreateNonSimstationRoomOutput
> {
	T = Translations;

	createNonSimstationRoomForm = new FormGroup({
		roomName: new FormControl("", [Validators.required]),
		roomGroup: new FormArray<FormControl<TrainingRoomGroup>>([], [Validators.required]),
	});

	public loading: boolean = false;

	constructor(
		_injector: Injector,
		private _simTrainingRoomService: SimTrainingRoomService,
	) {
		super(_injector);
	}

	createNonSimstationRoom() {
		this.loading = true;
		this._simTrainingRoomService
			.createNonSimulationRoom({
				name: this.createNonSimstationRoomForm.value.roomName,
				roomGroupId: this.createNonSimstationRoomForm.value.roomGroup[0].id,
			})
			.then((value) => {
				this.close({action: "ok"});
			});
	}

	cancel() {
		this.close({action: "cancel"});
	}
}
